import type { RouteObject } from "react-router-dom";
import About from "@/pages/about/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import Home from "@/pages/home/page";
import NotFound from "@/pages/NotFound";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/:type",
    element: <CategoryPage />,
  },
  {
    path: "/detail/:id",
    element: <DetailPage />,
  },
  {
    path: "/search",
    element: <SearchPage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;